import { FieldErrors } from 'react-hook-form';
import { formatUnits, parseValueSafe } from 'shared/lib/token/units';
import { isAddress } from 'viem';

import { SaleFormData, ValidationContext } from '../types';

export const validateForm = (
  { amount, referrer }: SaleFormData,
  context: ValidationContext,
): FieldErrors<SaleFormData> => {
  const { minPaymentAmount, paymentToken, userAddress } = context ?? {};

  const errors: FieldErrors<SaleFormData> = {};

  if (referrer) {
    if (!isAddress(referrer)) {
      errors.referrer = { type: 'valid-address', message: 'Invalid address' };
    } else if (userAddress && referrer.toLowerCase() === userAddress.toLowerCase()) {
      errors.referrer = { type: 'not-self', message: 'Cannot be your own address' };
    }
  }

  if (!amount) {
    errors.amount = { type: 'required', message: 'Amount is required' };
    return errors;
  }

  const parsedAmount = parseValueSafe(amount, paymentToken?.decimals);

  if (!parsedAmount) {
    errors.amount = { type: 'valid-number', message: 'Invalid number' };
    return errors;
  }

  if (userAddress && parsedAmount.isGreaterThan((paymentToken?.balance ?? 0)?.toString())) {
    errors.amount = { type: 'balance', message: 'Insufficient balance' };
    return errors;
  }

  if (minPaymentAmount && parsedAmount.isLessThan(minPaymentAmount.toString())) {
    const minFormatted = formatUnits(minPaymentAmount, paymentToken?.decimals);
    errors.amount = { type: 'min-amount', message: `Minimum is ${minFormatted}` };
    return errors;
  }

  return errors;
};
